<template>
  <div class="container-fluid">
    <div class="card shadow-sm border-0 mt-5 mb-3">
      <div class="card-header bg-white d-flex justify-content-between align-items-center">
        <h5 class="col-6">Usuarios</h5>
        <div class="col-6 text-end">
          <button type="button" class="btn btn-fbo" @click="generateFile()">
            Descargar lista de Usuarios
          </button>
        </div>
      </div>
      <div class="card-body" style="width: 100%; max-width: 100vw;">
        <div class="d-flex gap-2 justify-content-between align-items-center flex-wrap">
          <div class="col-md-5 mb-3 px-0">
            <div class="row">
              <div class="input-group">
                <input
                  class="form-control border-end-0 border"
                  type="search"
                  placeholder="Buscar..."
                  v-model="searchValue"
                />
                <span class="input-group-append">
                  <button class="btn btn-outline-secondary bg-white border-start-0 border-bottom-0 border ms-n5" type="button">
                    <i class="fa fa-search"></i>
                  </button>
                </span>
              </div>
            </div>
          </div>
  
          <div class="col-md-3 mb-3 px-0">
            <div class="select-wrapper">
              <label for="communitySelect" class="communitySelectLabel">Filtrar por comunidad</label>
              <select 
                id="communitySelect" 
                v-model="serverOptions.community" 
                class="form-control"
              >
                <option value="">Todas las comunidades</option>
                <option 
                  :key="c.UUID" 
                  v-for="c in communities" 
                  :value="c.UUID"
                >
                  {{ c.name }}
                </option>
              </select>
              <i class="fa fa-chevron-down select-icon"></i>
            </div>
          </div>
        </div>

        <div v-if="!loading" class="table-responsive" style="width: 100%;">
          <table class="table table-bordered settings-table mt-3" style="width: 100%; table-layout: auto;">
            <thead>
              <tr class="">
                <th @click="changeSort('first_name')" style="cursor: pointer;">
                  Nombre
                  <span v-if="serverOptions.sortBy === 'first_name'">
                    <i :class="serverOptions.sortType === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                  </span>
                </th>
                <th @click="changeSort('last_name')" style="cursor: pointer;">
                  Apellidos
                  <span v-if="serverOptions.sortBy === 'last_name'">
                    <i :class="serverOptions.sortType === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                  </span>
                </th>
                <th @click="changeSort('email')" style="cursor: pointer;">
                  Email
                  <span v-if="serverOptions.sortBy === 'email'">
                    <i :class="serverOptions.sortType === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                  </span>
                </th>
                <th @click="changeSort('telephone')" style="cursor: pointer;">
                  Teléfono
                  <span v-if="serverOptions.sortBy === 'telephone'">
                    <i :class="serverOptions.sortType === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                  </span>
                </th>
                <th @click="changeSort('user_type__name')" style="cursor: pointer;">
                  Tipo de usuario
                  <span v-if="serverOptions.sortBy === 'user_type__name'">
                    <i :class="serverOptions.sortType === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                  </span>
                </th>
                <th @click="changeSort('comunidad__name')" style="cursor: pointer;">
                  Comunidad
                  <span v-if="serverOptions.sortBy === 'comunidad__name'">
                    <i :class="serverOptions.sortType === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                  </span>
                </th>
                <th @click="changeSort('dateCreated')" style="cursor: pointer;">
                  Fecha de alta
                  <span v-if="serverOptions.sortBy === 'dateCreated'">
                    <i :class="serverOptions.sortType === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                  </span>
                </th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr class="align-middle" :key="item.UUID" v-for="item in users">
                <UserRow :user="item"></UserRow>
              </tr>
            </tbody>
          </table>

          <div class="d-flex flex-wrap justify-content-between align-items-center mt-3">
            <div class="text-muted">
              Mostrando
              {{ (serverOptions.page - 1) * serverOptions.rowsPerPage + 1 }} -
              {{ Math.min(serverOptions.page * serverOptions.rowsPerPage, serverItemsLength) }}
              de {{ serverItemsLength }} resultados (usuarios)
            </div>
            <div class="d-flex align-items-center gap-3">
              <span>líneas por página:</span>
              <select v-model.number="serverOptions.rowsPerPage" class="form-select form-select-sm w-auto">
                <option v-for="n in [10, 25, 50, 100]" :key="n" :value="n">{{ n }}</option>
              </select>
              <span>
                {{ (serverOptions.page - 1) * serverOptions.rowsPerPage + 1 }}-
                {{ Math.min(serverOptions.page * serverOptions.rowsPerPage, serverItemsLength) }}
                de {{ serverItemsLength }}
              </span>
              <button
                class="btn btn-sm btn-light"
                :disabled="serverOptions.page === 1"
                @click="serverOptions.page--"
              >
                <i class="fa fa-chevron-left"></i>
              </button>
              <button
                class="btn btn-sm btn-light"
                :disabled="serverOptions.page * serverOptions.rowsPerPage >= serverItemsLength"
                @click="serverOptions.page++"
              >
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
        <div v-else class="text-center py-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div>Cargando información</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserRow from "@/components/Users/UserRow.vue";
import UserService from "@/services/user.service.js";

export default {
  name: "Users",
  components: {
    UserRow,
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      users: [],
      communities: [],
      loading: true,
      searchValue: "",
      serverOptions: {
        page: 1,
        rowsPerPage: 25,
        sortBy: "dateCreated",
        sortType: "desc",
        community: "", 
      },
      serverItemsLength: 0,
    };
  },
  watch: {
    serverOptions: {
      handler() {
        this.getUsers();
      },
      deep: true,
    },
    searchValue() {
      this.serverOptions.page = 1;
      this.getUsers();
    },
  },
  methods: {
    async start() {
      this.loading = true;
      await this.fetchCommunities(); 
      await this.getUsers();
      this.loading = false;
    },

    async fetchCommunities() {
      try {
        const response = await UserService.getCommunities();
        this.communities = response.data;
      } catch (error) {
        console.error("Error fetching communities:", error);
      }
    },

    async getUsers() {
      this.loading = true;
      try {
        const response = await UserService.getAllUsers({
          ...this.serverOptions,
          search: this.searchValue,
        });
        this.users = response.data.items;
        this.serverItemsLength = response.data.serverItemsLength;
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.loading = false;
      }
    },

    async generateFile() {
      this.loading = true;
      try {
        const response = await UserService.export_users_list();
        if (response.data) {
          console.log("Response data: ", response.data);
          this.xlsx = response.data;
        } else {
          console.error("Empty response data");
        }
      } catch (error) {
        console.error("Error:", error);
        if (error.response && error.response.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            console.log("Error HTML content:", reader.result);
          };
          reader.readAsText(error.response.data);
        }
      } finally {
        this.loading = false;
      }
    },
    changeSort(field) {
      if (this.serverOptions.sortBy === field) {
        this.serverOptions.sortType = this.serverOptions.sortType === "asc" ? "desc" : "asc";
      } else {
        this.serverOptions.sortBy = field;
        this.serverOptions.sortType = "asc"; // default to ascending
      }
    },
  },
  created() {
    this.start();
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
th {
  font-size: 14px;
}

.communitySelectLabel{
  display: none;
}

.select-wrapper {
  position: relative;
}

.select-wrapper select {
  appearance: none; 
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 2rem;
}

.select-wrapper .select-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none; /* que no bloquee clics */
  color: #666;
}

</style>
